import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) =>
    console.error(err)
);

const fullUrl = window?.location?.href;
if (fullUrl.includes('?') && fullUrl.includes('#')) {
    const queryStart = fullUrl.indexOf('?');
    const hashStart = fullUrl.indexOf('#');
    const queryString = fullUrl.substring(queryStart + 1, hashStart);
    sessionStorage.setItem('digilockerParams', queryString);
}
